"use strict";
var pagination_component_1 = require('./pagination/pagination.component');
var pager_component_1 = require('./pagination/pager.component');
var pagination_component_2 = require('./pagination/pagination.component');
exports.PaginationComponent = pagination_component_2.PaginationComponent;
var pager_component_2 = require('./pagination/pager.component');
exports.PagerComponent = pager_component_2.PagerComponent;
exports.PAGINATION_DIRECTIVES = [pagination_component_1.PaginationComponent, pager_component_1.PagerComponent];



/*****************
 ** WEBPACK FOOTER
 ** ./~/ng2-bootstrap/components/pagination.js
 ** module id = 818
 ** module chunks = 0
 **/